import React from 'react';
import {
  withStyles,
  withMobileDialog,
  Button,
  IconButton,
  Icon,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import CreateEventModal from './components/CreateEventModal';
import styles from './styles';

export class CreateEventButtonComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = { showCreateEventModal: false };
  }

  toggleCreateEventModal = () => {
    this.setState((prevState) => ({ showCreateEventModal: !prevState.showCreateEventModal }));
  }

  render() {
    const {
      classes,
      fullScreen,
    } = this.props;
    return (
      <div>
        {
          !!fullScreen
            && (
              <IconButton
                size="small"
                className={classes.button}
                onClick={this.toggleCreateEventModal}
                id="button-create-event"
                color="inherit"
              >
                <Icon>add</Icon>
              </IconButton>
            )
        }
        {
          !fullScreen
            && (
              <Button
                size="small"
                className={classes.button}
                onClick={this.toggleCreateEventModal}
                id="button-create-event"
              >
                Start Workflow
              </Button>
            )
        }
        {
          this.state.showCreateEventModal
            && (
              <CreateEventModal
                isOpen={this.state.showCreateEventModal}
                toggleCreateEventModal={this.toggleCreateEventModal}
              />
            )
        }
      </div>
    );
  }
}

CreateEventButtonComponent.propTypes = {
  classes: PropTypes.object,
  fullScreen: PropTypes.bool,
};

CreateEventButtonComponent.defaultProps = {
  classes: {},
  fullScreen: false,
};

export default withMobileDialog({ breakpoint: 'xs' })(withStyles(styles, { withTheme: true })(CreateEventButtonComponent));
